import { Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from './service/app.layout.service';
import { UserService } from '../core/services/user.service';

@Component({
  selector: 'globot-sidebar',
  templateUrl: './app.sidebar.component.html',
})
export class AppSidebarComponent {
  constructor(
    public layoutService: LayoutService,
    public el: ElementRef,
    private router: Router,
    private userService: UserService
  ) {}

  get isInsideBot(): boolean {
    return /edit-bot\//.test(this.router.routerState.snapshot.url);
  }

  openHelp(): void {
    window.open('https://globot.ai/tutoriales/', '_blank', 'noopener');
  }

  logout(): void {
    this.userService.logout();
  }
}
